import React, { useState, useEffect } from 'react';

import {
    Accordion,
    AccordionContent,
    AccordionTitle,
    RadioWithLabel,
    RadioInput,
    RadioLabel,
    Typography,
} from '@hpi-sox/hpstellar-core';

export default ({ clickOnEnter, sortValues, onSort, sortValue }) => {
    const [inpSort, setInpSort] = useState(null);

    useEffect(() => {
        if (typeof inpSort === 'string') {
            setInpSort(null);
        }
    }, [sortValue]);

    const getOnChange = key => () => {
        setInpSort(key);
        setTimeout(() => {
            onSort(key);
        }, 0);
    };

    const derivedSort = typeof inpSort === 'string' ? inpSort : sortValue;
    return (
        Array.isArray(sortValues) && (
            <Accordion className="mobileSort accordion" size="small" defaultExpanded>
                <AccordionTitle onKeyUp={clickOnEnter} title="SORT BY" />
                <AccordionContent className="accordionContent sortMobileContent">
                    {sortValues.map(({ title, key }) => {
                        const checked = derivedSort === key;
                        return (
                            <RadioWithLabel checked={checked} key={key}>
                                <RadioLabel className="radioContainer">
                                    <Typography>{title}</Typography>
                                    <RadioInput checked={checked} value={key} onChange={getOnChange(key)} />
                                </RadioLabel>
                            </RadioWithLabel>
                        );
                    })}
                </AccordionContent>
            </Accordion>
        )
    );
};
